import {FieldType} from "./FieldType";

export class FieldDefinition {
    constructor(public name: string,
                public displayName: string,
                public fieldType: FieldType,
                public displayWidth?: number
    ) {}
}